module.exports = __webpack_public_path__ + "static/media/elon_musk.62587c60.jpg";